
function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

const routes_base = [
  { path: 'booking/order_list_new', component: loadPage('OrderListNew', 'booking/order') },
  { path: 'booking/order_list_all', component: loadPage('OrderListAll', 'booking/order') },
  { path: 'booking/order_detail', component: loadPage('OrderDetail', 'booking/order') },
  { path: 'booking/order_create', component: loadPage('OrderCreate', 'booking/order') },
  { path: 'booking/order_calendar', component: loadPage('OrderCalendar', 'booking/order') },

  // 정산
  { path: 'booking/account/new', component: loadPage('AccountNew', 'booking/order') },
  { path: 'booking/account/all', component: loadPage('AccountAll', 'booking/order') },
  { path: 'booking/account/setting', component: loadPage('AccountSetting', 'booking/order') },

];


const routes_admin = [

];


const routes = {
  'base': routes_base,
  'admin': routes_admin.concat(routes_base)
};

export default routes;

